// 指摘内容は1ファイルの最大行数（500行）の超過であるため、処理内容自体の問題はないと判断。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import loading from '../../../share/components/vue/ProcessingIcon';
import api from '../../../common/api';
import config from '../../../share/config';
import handler from '../../../share/util/apiResultValidator';
import session from '../../../share/session';
import error from '../../../common/nodejs/errors';
import constants from '../../../common/nodejs/constants';
import alert from '../../../share/alert';
import imbGetNoOfRegkeystype3 from '../../vue/IMBGetNoOfRegkeysType3';
import imbGetNoOfRegkeysType1_2 from '../../vue/IMBGetNoOfRegKeysType1_2';
import imbRegisterECUType2 from '../../vue/IMBRegisterECUType2';
import imbRegisterECUType1 from '../../vue/IMBRegisterECUType1';
import imbRegisterECUType3 from '../../vue/IMBRegisterECUType3';
import registerImbSystemType1 from '../../vue/RegisterImbSytemType1';
import imbRegIMBSysType2 from '../../vue/IMBRegIMBSysType2';
import imbRegisterKeylessAccessType3 from '../../vue/IMBRegisterKeylessAccessType3';
import imbRegisterRemoteEngineStartCUType1 from '../../vue/IMBRegisterRemoteEngineStartCUType1';
import imbRegisterRemoteEngineStartCUType2 from '../../vue/IMBRegisterRemoteEngineStartCUType2';
import imbRegisterRemoteEngineStartCUType3 from '../../vue/IMBRegisterRemoteEngineStartCUType3';
import imbRegTelematicsCUType3 from '../../vue/IMBRegisterTelematicsCUType3';
import imbRegTelematicsCUType2 from '../../vue/IMBRegisterTelematicsCUType2';
import { getErrorMessageKey, getErrorMessageKeyIocpRcidStatus, getErrorMessageCauseAndAction } from './errorMsgClient';
import imbDeleteIdOfImmobilizerKeyType1 from '../../vue/ImbDeleteIdOfImmobilizerKeyType1';
import imbDeleteIdofImbKeyType2 from '../../vue/IMBDeleteIdOfImbKeyType2';
import imbDeleteIdofImbKeyType3 from '../../vue/IMBDeleteIdOfImbKeyType3';
import imbRegCentralGatewayType2 from '../../vue/IMBRegCentralGatewayType2';
import imbRegisterSteeringLockCUType3 from '../../vue/IMBRegisterSteeringLockCUType3';
import imbRegCombinationMeterType1 from '../../vue/ImbRegCombinationMeterType1';
import imbRegCombinationMeterType2 from '../../vue/ImbRegCombinationMeterType2';
import imbGetTheRegistrationHistoryType3 from '../../vue/IMBGetTheRegistrationHistoryType3';
import imbDeleteAllKeys from '../../vue/IMBDeleteAllKeys';
import immobilizer from '../../../share/util/immobilizer';
import { convertProcessNameToProcessNumber } from './util';
import eventLogUtil from '../../../share/util/eventLogUtil';
import { PROCESS, FUNCTION_NAME, STATUS, API_ENDPOINT, VEHICLE_TYPE } from './constants';
import { IMMOBILIZER } from '../../../constants/usageCountTypes';
import { IMB_DELETE_ALL_KEYS_PROGRESS_LIST, IMB_DELETE_ALL_KEYS_ERROR_MAP, imbDeleteAllKeysError, DELETE_ALL_KEYS_ACTION } from './imbDeleteAllKeys/deleteAllKeysRules';

let ecuCounter = 1;
let ok_flag = false;
const SWITCH_IG_ON_RETRY_COUNTER = 4;
const SWITCH_IG_ON_RETRY_COUNTER_KEY_LESS = 3;

export default {


  data() {
    return {
      processing: false,
      watcher: null,
      imbStatusInfo: {},
      igOn: false,
      endOfRegKey: false,
      processNumber: 0,
      resumeIntr: false,
      vehicleTypeDisplayText: '',
      isRequireGetProcessName: false,
      isReturnedFromDisconnection: false,
      endOfProcessingFlag: false,
      causesAndActionList: [
        error.IMB_CANNOT_OPEN_DEVICE_ERROR,
        error.IMB_CANNOT_CONNECT_DEVICE_ERROR,
        error.IMB_SYSTEM_ERROR,
        error.IMB_CENTRAL_GATEWAY_CLOUD_NO_RESPONSE_AUTHORIZATION_ERROR
      ],
      showNumberOfRegisteredKeysErrorCodeList: [
        error.IMB_MODE_TRANSITION_FAILURE_ERROR,
        error.IMB_CANNOT_CONFIRM_CURRENT_STATUS_ERROR,
        error.IMB_CANNOT_CONFIRM_ACCESS_KEY_ERROR,
        error.IMB_TIMEOUT_DURING_ACCESS_KEY_COLLATION_ERROR,
        error.IMB_NUMBER_OF_ACCESSKEY_REGISTRATIONS_EXCEEDED_ERROR,
        error.IMB_TIMEOUT_DURING_IGNITION_SWITCH_OFF_ERROR,
        error.IMB_TIMEOUT_DURING_IGNITION_SWITCH_ON_ERROR,
        error.IMB_UNSET_FALURE_ERROR,
        error.IMB_FAILED_TO_REGISTRATION_ERROR
      ],
      dialog_id: '',
      dialog_visible: false,
      executeRspMsgCheckTimeout: Number(process.env.VUE_APP_IMB_CC_RSP_MAX_INTERVAL),
      isButtonPush: false,
      buttonPushStatus: '',

      // dialog表示のための変数
      modalShowInfo: {},
      modal_return_to_home_screen: false

    };
  },

  // router params 対応
  props: ["response"],

  components: {
    'processing-view': loading,
    'imb-get-no-of-reg-keys-type-1-2': imbGetNoOfRegkeysType1_2,
    'imb-get-no-of-reg-keys-type-3': imbGetNoOfRegkeystype3,
    'imb-register-ecu-type-1': imbRegisterECUType1,
    'imb-register-ecu-type-2': imbRegisterECUType2,
    'imb-register-ecu-type-3': imbRegisterECUType3,
    'register-imb-system-type-1': registerImbSystemType1,
    'register-imb-system-type-2': imbRegIMBSysType2,
    'imb-register-keyless-access-type-3': imbRegisterKeylessAccessType3,
    'imb-register-remote-engine-start-cu-type-1': imbRegisterRemoteEngineStartCUType1,
    'imb-register-remote-engine-start-cu-type-2': imbRegisterRemoteEngineStartCUType2,
    'imb-register-remote-engine-start-cu-type-3': imbRegisterRemoteEngineStartCUType3,
    'imb-register-telematics-cu-type-2': imbRegTelematicsCUType2,
    'imb-register-telematics-cu-type-3': imbRegTelematicsCUType3,
    'imb-delete-id-of-imb-key-type-1': imbDeleteIdOfImmobilizerKeyType1,
    'imb-delete-id-of-imb-key-type-2': imbDeleteIdofImbKeyType2,
    'imb-delete-id-of-imb-key-type-3': imbDeleteIdofImbKeyType3,
    'imb-reg-central-gateway-type-2': imbRegCentralGatewayType2,
    'imb-register-steering-lock-cu-type-3': imbRegisterSteeringLockCUType3,
    'imb-register-combination-meter-type1': imbRegCombinationMeterType1,
    'imb-register-combination-meter-type2': imbRegCombinationMeterType2,
    'imb-get-the-registration-history-type3': imbGetTheRegistrationHistoryType3,
    'imb-delete-all-keys': imbDeleteAllKeys
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleType: state => state.immobilizer.vehicleType,
      menuList: state => state.immobilizer.menuList,
    }),
  },

  watch: {
    endOfProcessingFlag: function (value) {
      if (this.isReturnedFromDisconnection && value) {
        this.modal_return_to_home_screen = true;
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('netAppConnector', ['getPairingStatus']),
    ...mapActions('observation', ['usageCountUp']),

    isVisible: function (key) {
      return this.menuList.includes(key);
    },

    // Error 原因・対策ダイアログ表示対象判定
    isCausesAndActionDialog: function (err_code) {
      return this.causesAndActionList.includes(err_code);
    },

    // Error 登録済みアクセスキー本数表示対象判定
    isShowNumberOfRegisteredAccessKeys: function (err_code) {
      return this.showNumberOfRegisteredKeysErrorCodeList.includes(err_code);
    },

    // get no of registered keys  

    // new api call

    //for get no of reg keys
    postRegisteredKeys: async function () {
      try {
        this.processing = true;
        const startImbResponse = await api.postCall(config.IMB, '/numberOfRegisteredKeyStartReading/' + this.netAppId, {});
        const isSuccess = handler.validate(handler.validateTypes.all, startImbResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.processing = false;
          return;
        }
        // Start imb status monitoring
        await this.setupWatcher();
      } catch (error) {
        this.processing = false;
      }
    },

    // for getting IMB Status
    // 指摘内容は1関数の最大複雑度（20）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity */
    getImbStatus: async function () {
      this.executeRspMsgCheckTimeout -= (process.env.VUE_APP_RETRY_INTERVAL / 1000);
      try {
        let getImbStatusResponse = await api.getCall(config.IMB, '/imbGetStatus/' + this.netAppId);
        const isSuccess = handler.validate(handler.validateTypes.all, getImbStatusResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          return;
        }
        getImbStatusResponse = getImbStatusResponse.data;

        let pairingStatus = null;
        // ステータスの問い合わせ
        const param = {
          this: this,
          netAppId: null
        };
        const pairingResponse = await this.getPairingStatus(param);
        pairingStatus = pairingResponse.response.data;
        // IMBは実行中に一定時間 CC からの応答がなければ処理終了
        if (!pairingStatus.repro_exec_rsp_received && this.executeRspMsgCheckTimeout <= 0) {
          this.showUnexpectedErrorModal(this.$t('error.IOT_DOES_NOT_ARRICE_FROM_CC'));
          return;
        }

        if (this.isRequireGetProcessName) {
          this.processNumber = convertProcessNameToProcessNumber(getImbStatusResponse.process_name, this.vehicleType);
          if (this.processNumber !== 0) this.isRequireGetProcessName = false;
        }

        if (this.processNumber === constants.GET_REGISTERED_KEYS_PROCESS_NO) {
          this.imbgetRegKeyProcess(getImbStatusResponse);
        } else if (this.processNumber === constants.GET_REGISTERED_ACCESSS_KEYS_PROCESS_NO) {
          this.imbgetRegAcesssKeyProcess(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_ECU_TYPE_1_PROCESS_NO) {
          this.imbRegECUType1Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_ECU_TYPE_2_PROCESS_NO) {
          this.imbRegECUType2Process(getImbStatusResponse);
        } else if ([constants.REGISTER_ECU_TYPE_3_PROCESS_NO, PROCESS.REGISTER_HV_ECU.NUMBER].includes(this.processNumber)) {
          // ECU登録 (type3) とHVECU登録は同じプロセスを実行する
          this.imbRegECUType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_IMB_SYSTEM_TYPE_1_PROCESS_NO) {
          this.imbRegIMBSysType1Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_IMB_SYSTEM_TYPE_2_PROCESS_NO) {
          this.imbRegIMBSysType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_KEYLESS_IMB_SYSTEM_TYPE_3_PROCESS_NO) {
          this.imbRegKeylessIMBSysType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REMOTE_ENGINE_START_CU_TYPE_1_PROCESS_NO) {
          this.imbRegRemoteEngineStartCUType1Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REMOTE_ENGINE_START_CU_TYPE_2_PROCESS_NO) {
          this.imbRegRemoteEngineStartCUType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REMOTE_ENGINE_START_CU_TYPE_3_PROCESS_NO) {
          this.imbRegRemoteEngineStartCUType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.TELEMATICS_CU_TYPE_2_PROCESS_NO) {
          this.imbRegTelematicsCUType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.TELEMATICS_CU_TYPE_3_PROCESS_NO) {
          this.imbRegTelematicsCUType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_CENTRAL_GATEWAY_TYPE_2_PROCESS_NO) {
          this.imbRegCentralGatewayType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.DELETE_ID_OF_IMB_KEY_TYPE_1_PROCESS_NO) {
          this.imbDeleteIdOfImbKeyType1Process(getImbStatusResponse);
        } else if (this.processNumber === constants.DELETE_ID_OF_IMB_KEY_TYPE_2_PROCESS_NO) {
          this.imbDeleteIdOfImbKeyType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.DELETE_ID_OF_ACCESS_KEY_TYPE_3_PROCESS_NO) {
          this.imbDeleteIdOfImbKeyType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_STEERING_LOCK_CU_TYPE_3_PROCESS_NO) {
          this.imbRegSteeringLockCUType3Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_COMBINATION_METER_TYPE_1_PROCESS_NO) {
          this.imbRegCombinationMeterType1Process(getImbStatusResponse);
        } else if (this.processNumber === constants.REGISTER_COMBINATION_METER_TYPE_2_PROCESS_NO) {
          this.imbRegCombinationMeterType2Process(getImbStatusResponse);
        } else if (this.processNumber === constants.GET_REGISTRATION_HISTORY_TYPE_3_PROCESS_NO) {
          this.imbGetRegistrationHistoryType3Process(getImbStatusResponse);
        } else if (this.processNumber === PROCESS.DELETE_ALL_KEYS.NUMBER) {
          this.imbDeleteAllKeysProcess(getImbStatusResponse);
        }
      } catch (error) {
        // 'Unexpected error has occurred'
      }
    },

    // get no of registered keys  type 1 and type 2

    // Confirmation dialog box register keys type 1 and type 2
    onClickGetRegisterKeys: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      this.showDialogBoxes('modal-confirm-no-of-reg-keys', '');
    },

    //on OK button click from get no of reg keys type 1 and type 2
    onClickOkGetRegKeys: async function () {
      this.processNumber = constants.GET_REGISTERED_KEYS_PROCESS_NO;
      this.hideWrap();
      await this.createEventLogRecord(constants.FUNCTION_NAME_GET_THE_NUMBER_OF_REGISTERED_KEY);
      await this.postRegisteredKeys();
    },

    imbgetRegKeyProcess: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      // Checking executing/success/failed status
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_NUMBER_OF_REGISTER_KEYS) {
          this.processing = true;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED_READING_OF_NUMBER_OF_KEYS) {
          this.clearWatcher();
          this.processing = false;
          error_msg = this.$t('imb.common_num_reg_keys_type1_type2', [getImbStatusResponse.num_of_registered_keys]);
          // error_msg = "registered_key";
          this.showDialogBoxes('modal-imb-get-reg-key-result', error_msg);
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        //Switching process according to the error_code  
        if (getImbStatusResponse.error_code === error.IMB_KEY_REG_UNSUCCESSFUL_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
        } else if (getImbStatusResponse.error_code === error.IMB_KEY_DELETION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-imb-get-reg-key-error', error_msg);
      }

      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;

    },

    // get no of registered access keys  type 3

    // Confirmation dialog box register access key type 3
    onGetRegAccessKeyType3ButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      this.showDialogBoxes('registered-access-key-type-3', '');
    },

    //on OK button click from get no of reg access keys type 3
    onConfirmationOkButtonClick: async function () {
      this.processNumber = constants.GET_REGISTERED_ACCESSS_KEYS_PROCESS_NO;
      this.hideWrap();
      await this.createEventLogRecord(constants.FUNCTION_NAME_GET_THE_NUMBER_OF_REGISTERED_ACCESS_KEY);
      await this.postRegisteredKeys();
    },

    imbgetRegAcesssKeyProcess: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      // Checking executing/success/failed status
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_NUMBER_OF_REGISTER_ACCESS_KEYS) {
          this.processing = true;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED_READING_OF_NUMBER_OF_ACCESS_KEYS) {
          this.clearWatcher();
          this.processing = false;
          error_msg = this.$t('imb.common_num_reg_keys_type3', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('registered-access-key-type-3-success', error_msg);
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        //Switching process according to the error_code         
        if (getImbStatusResponse.error_code === error.IMB_KEY_REG_UNSUCCESSFUL_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
        } else if (getImbStatusResponse.error_code === error.IMB_KEY_DELETION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('registered-access-key-type-3-failure', error_msg);
      }

      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },


    // Setup Timer
    setupWatcher: async function () {
      this.executeRspMsgCheckTimeout = Number(process.env.VUE_APP_IMB_CC_RSP_MAX_INTERVAL);
      this.watcher = this.$startInterval(async () => {
        await this.getImbStatus();
      }, process.env.VUE_APP_RETRY_INTERVAL, "getImbStatus", true);
    },

    // Clear Timer
    clearWatcher: function () {
      if (this.watcher) {
        this.$stopInterval(this.watcher);
        this.watcher = null;
      }
      this.executeRspMsgCheckTimeout = Number(process.env.VUE_APP_IMB_CC_RSP_MAX_INTERVAL);
    },


    // Display a dialog when an unexpected error occurs
    showUnexpectedErrorModal: function (msg) {
      this.clearWatcher();
      alert.showError(this, null, msg, () => { this.logout(this); });
    },


    // Register ECU 

    //display Confirmation dialog box based on type
    onRegisterEcuButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B1") {
        this.showDialogBoxes('modal-confirm-to-start-ecu-regECUType1', '');
      } else if (this.vehicleType === "B2" || this.vehicleType === "E" || this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('register-ECU-type-2', '');
      } else if (this.vehicleType === "D" || this.vehicleType === "H1" || this.vehicleType === "H2") {
        this.showDialogBoxes('modal-confirm-start-ecu-registration-type3', '');
      }
    },

    // new api call

    // calling API IGON
    callingIGONAPI: async function (endpoint) {
      this.igOn = false;
      try {
        this.processing = true;
        const token = session.getToken();
        const startIMBResponse = await api.postCall(config.IMB, `${endpoint}` + this.netAppId, {
          id_token: token.id_token,
        });

        const isSuccess = handler.validate(handler.validateTypes.all, startIMBResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.igOn = false;
          return;
        }
        this.igOn = true;

      } catch (error) {
        //unexpected error
        this.igOn = false;
      }

    },

    //calling postCancel Api
    postCancelOnButtonClick: async function () {
      try {
        const postCancelResponse = await api.postCall(config.IMB, '/imbPostCancel/' + this.netAppId, {});
        const isSuccess = handler.validate(handler.validateTypes.all, postCancelResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          return;
        }
        this.igOn = false;
      } catch (error) {
        // 'Unexpected error has occurred'
      }

    },

    // calling notifyOkBtn API
    notifyOkBtnAPI: async function (endpoint, isExitProcess = null) {
      try {
        this.processing = true;
        const body = isExitProcess ? { vehicle_type: this.vehicleType, is_pressed: false } : { vehicle_type: this.vehicleType };
        const notifyIMBResponse = await api.postCall(config.IMB, `${endpoint}` + this.netAppId, body);

        const isSuccess = handler.validate(handler.validateTypes.all, notifyIMBResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          return;
        }
      } catch (error) {
        //unexpected error
      }
      return;
    },

    // Register ECU Type 1

    //confirmation ok button click register ECU type1
    onRegECUType1OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_ECU_TYPE_1_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_ECU, constants.IMB_START_REGISTRAION_REGISTER_ECU);
    },

    //IGON ok button click reg ecutype1
    IgOnType1OkButtonClick: async function () {
      this.showDialogBoxes('modal-process-is-going-on-regECUType1', this.$t('imb.common_process_comm_with_biu'));
      //call api-03 method
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_ECU);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    //Register ECU Type1 GetStatus api response validation
    imbRegECUType1Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-regECUType1', error_msg);
        }
        else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PREPARED_TO_START_REGISTRATION) {
          if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === false) {
            error_msg = this.$t('imb.common_processing_comm_with_ecm_reg');
            this.showDialogBoxes('modal-process-is-going-on-regECUType1', error_msg);
          } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === true) {
            this.igOn = false;
            this.clearWatcher();
            this.showDialogBoxes('modal-ecu-registration-completed-regECUType1', error_msg);
          } else {
            error_msg = this.$t('imb.common_process_comm_with_biu');
            this.showDialogBoxes('modal-process-is-going-on-regECUType1', error_msg);
          }
        } else {
          this.processing = true;
        }
      } else {
        this.hideWrap();
        this.processing = false;
        this.clearWatcher();
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regECUType1', error_msg);
      }
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    // Register ECU Type 2

    // Confirmation ok button click register ECU type2
    onRegisterECUType2OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_ECU_TYPE_2_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_ECU, constants.IMB_START_REGISTRAION_REGISTER_ECU);
    },

    //Register ECU Type2 GetStatus api response validation
    imbRegECUType2Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('register-ECU-type-2-confirm-ig-is-on', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          this.showDialogBoxes('register-ECU-type-2-warning-ig-on', error_msg);
          ecuCounter = ecuCounter + 1;
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEYS_NOT_REGISTERED) {
          this.clearWatcher();
          this.showDialogBoxes('register-ECU-type-2-warning-key-not-found', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('register-ECU-type-2-confirm-igon', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PREPARED_TO_START_REGISTRATION) {
          if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === true) {
            this.clearWatcher();
            this.igOn = false;
            ecuCounter = 1;
            this.showDialogBoxes('register-ECU-type-2-success', error_msg);
          } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === false) {
            error_msg = this.$t('imb.common_processing_comm_with_ecm_reg');
            this.showDialogBoxes('register-ECU-type-2-progress-comm-BIU', error_msg);
          } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
            error_msg = this.$t('imb.common_process_comm_with_biu');
            this.showDialogBoxes('register-ECU-type-2-progress-comm-BIU', error_msg);
          } else {
            this.processing = true;
          }
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        ecuCounter = 1;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('register-ECU-type-2-failure', error_msg);
      }

      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    callIGONAPIOnClickRetryOrOkButton: async function () {
      let error_msg = '';
      this.hideWrap();
      error_msg = this.$t('imb.common_process_comm_with_biu');
      this.imbStatusInfo =
      {
        error_message: error_msg
      };
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_ECU);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    // Event on back click
    backEventOnButtonClick: async function () {
      this.hideWrap();
      this.igOn = false;
      this.clearWatcher();
      await this.postCancelOnButtonClick();
      this.processing = false;
    },

    // Register ECU Type 3

    //confirmation ok button click register ECU type3
    onRegECUType3OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = ["J"].includes(this.vehicleType) ? PROCESS.REGISTER_HV_ECU.NUMBER : constants.REGISTER_ECU_TYPE_3_PROCESS_NO;
      const functionName = ["J"].includes(this.vehicleType) ? FUNCTION_NAME.REGISTER_HVECU : constants.FUNCTION_NAME_REGISTER_ECU;
      await this.startRegistrationAndCreateLogRecord(functionName, constants.IMB_START_REGISTRAION_REGISTER_ECU);
    },

    //Register ECU Type3 GetStatus api response validation
    imbRegECUType3Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if ([constants.IMB_STATUS_REGISTER_ECU, STATUS.REGISTER_HVECU].includes(getImbStatusResponse.current_program_status)) {
        if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.imb_complete === false) {
          getImbStatusResponse.imb_status = getImbStatusResponse.current_program_status;
        } else if (getImbStatusResponse.imb_complete === true) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
        }
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-register-ecu-type3-ig-on', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_IG_ON_AGAIN) {
          if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER_KEY_LESS) {
            this.$pauseInterval(this.watcher);
            this.showDialogBoxes('modal-register-ecu-type3-ig-off', error_msg);
            ecuCounter++;
          } else {
            this.$pauseInterval(this.watcher);
            this.showDialogBoxes('modal-register-ecu-type3-warning', error_msg);
            ecuCounter++;
            this.updateImbEventLogIgOnFailed();
          }
        } else if ([constants.IMB_STATUS_REGISTER_ECU, STATUS.REGISTER_HVECU].includes(getImbStatusResponse.imb_status)) {
          this.showDialogBoxes('modal-register-ecu-type3-progress', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          ecuCounter = 1;
          this.showDialogBoxes('modal-register-ecu-type3-completed', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_VEHICLE_STATUS) {
          this.processing = true;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          this.processing = true;
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-register-ecu-type3-error', error_msg);

      }
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;

    },

    IgOnType3OkButtonClick: async function () {
      this.hideWrap();
      //call api-03 method
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_ECU);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    IgOnRetryType3OkButtonClick: async function () {
      this.hideWrap();
      await this.notifyOkBtnAPI(constants.IMB_NOTIFY_OK_BTN_PUSHED);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    IgOnRetryType3WarningClose: async function () {
      this.hideWrap();
      this.clearWatcher();
      // is_pressed フラグをOFFにしてプロセスの終了を通知
      await this.notifyOkBtnAPI(constants.IMB_NOTIFY_OK_BTN_PUSHED, true);
      this.processing = false;
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    onErrorType3OkButtonClick: async function () {
      this.hideWrap();
      this.igOn = false;
      ecuCounter = 1;
      this.clearWatcher();
      await this.postCancelOnButtonClick();
      this.processing = false;
    },

    // Register HVECU
    onRegisterHvEcuButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: IMMOBILIZER });

      this.showDialogBoxes('modal-confirm-start-ecu-registration-type3', '');
    },

    // Register Immobilizer System

    onRegisterIMBSysButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B1") {
        this.showDialogBoxes('modal-confirm-register-imb-system-type1', '');
      } else if (this.vehicleType === "B2" || this.vehicleType === "E" || this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('register-imb-sys-type-2-start-reg-confirm', '');
      }
    },

    // new api call

    endOfKeyRegistration: async function () {
      try {
        const startIMBResponse = await api.postCall(config.IMB, '/endOfKeyRegistration/' + this.netAppId, {
          vehicle_type: this.vehicleType,
        });

        const isSuccess = handler.validate(handler.validateTypes.all, startIMBResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.endOfRegKey = false;
          return;
        }
        this.endOfRegKey = true;
      } catch (error) {
        //unexpected error
      }
    },

    notifyEndOfProcess: async function () {
      try {
        const startIMBResponse = await api.postCall(config.IMB, '/notifyEndOfProcess/' + this.netAppId, {
        });
        const isSuccess = handler.validate(handler.validateTypes.all, startIMBResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          return;
        }
      } catch (error) {
        //unexpected error
      }
    },

    // Register Immobilizer System type 1

    onConfirmOkButtonClickRegImbType1: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_IMB_SYSTEM_TYPE_1_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_IMMOBILIZER_SYSTEM, constants.IMB_START_REGISTRAION_REGISTER_IMB_SYSTEM);
    },

    // 指摘内容は1関数の最大複雑度（20）と最大行数（50行）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity, max-statements */
    imbRegIMBSysType1Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';

      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTER_EGI;
      } else if (getImbStatusResponse.current_program_status === constants.IMB_SYS_STATUS_FINISHED_PROCESS && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_SYS_STATUS_FINISHED_KEY_REG_PROCESS;
      } else if (getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (this.isButtonPush) {
        if (this.buttonPushStatus === getImbStatusResponse.current_program_status) {
          return;
        } else {
          this.isButtonPush = false;
        }
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTER_EGI) {
          error_msg = this.$t('imb.common_processing_comm_with_ecm_reg');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_MATCHING_KEY1_MATCHING) {
          error_msg = this.$t('imb.register_immobilizer_system_process_key_id');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_MATCHING_KEY1_END) {
          error_msg = this.$t('imb.register_immobilizer_system_key_id_established_register_now') + '</br></br>' +
            this.$t('imb.register_immobilizer_system_igni_off_prep_reg_key_igni_on') + '</br>' + this.$t('imb.register_immobilizer_system_note_30_seconds');
          this.showDialogBoxes('modal-process-status-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_REGISTERING) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_key_reg');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTRATION_REGISTERED) {
          error_msg = this.$t('imb.register_immobilizer_system_key_is_already_reg') + '</br>' + this.$t('imb.common_num_reg_keys', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('modal-quit-display-regkey-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_COMPLETE_REGISTER_LIMIT) {
          error_msg = this.$t('imb.common_num_reg_keys', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('modal-key-register-limit-register-imb-system-type1', error_msg);//ok button
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_COMPLETE_REGISTER) {
          if (getImbStatusResponse.num_of_registered_keys > 0) {
            error_msg = this.$t('imb.register_imb_system_Key_has_registered') + '</br>' + this.$t('imb.common_num_reg_keys', [getImbStatusResponse.num_of_registered_keys]);
            this.showDialogBoxes('modal-quit-display-regkey-register-imb-system-type1', error_msg);//qut button
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING_KEY_END) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_imb_system_reg');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING_KEY_END) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_imb_system_reg');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_START_BIU_EXCHANGE) {
          error_msg = this.$t('imb.register_immobilizer_system_prep_all_key_prev_reg_match');
          this.showDialogBoxes('modal-process-status-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_MATCHING2_READING) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_confirm_key_id');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_MATCHING2_READ_OUT) {
          error_msg = this.$t('imb.register_immobilizer_system_key_confirmed_key_read') + '</br>' +
            this.$t('imb.register_immobilizer_system_num_key_not_read', [getImbStatusResponse.num_of_registered_keys]) + '</br>' +
            this.$t('imb.register_immobilizer_system_igni_off_chg_key_not_read') + '</br>' + this.$t('imb.register_immobilizer_system_note_30_seconds');
          this.showDialogBoxes('modal-process-status-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_MATCHING2_READ_COMPLETE) {
          error_msg = this.$t('imb.register_immobilizer_system_key_confirmed') + '</br>' +
            this.$t('imb.register_immobilizer_system_num_key_not_read', [getImbStatusResponse.num_of_registered_keys]) + '</br>' +
            this.$t('imb.register_immobilizer_system_igni_off_chg_key_not_read') + '</br>' + this.$t('imb.register_immobilizer_system_note_30_seconds');
          this.showDialogBoxes('modal-process-status-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_COMBINATION_METER_SECURITY_CM_IS_NOT_COMPLETED) {
          this.$pauseInterval(this.watcher);
          error_msg = this.$t('imb.combination_meter_security_cm_is_not_completed') + '</br>' + this.$t('imb.combination_meter_security_cm_is_perfrom');
          this.showDialogBoxes('modal-register-immobilizer-type1-warning', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_COMBINATION_METER_SECURITY_CM_REGISTRATION_FAILURE) {
          this.$pauseInterval(this.watcher);
          error_msg = this.$t('imb.error_combination_meter_security_cm_registration_failure') + '</br>' + this.$t('imb.error_combination_meter_security_cm_registration_diagnose');
          this.showDialogBoxes('modal-register-immobilizer-type1-warning', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_SSM_COMMUNICATION_ABNORMALITY) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-registering-mode-undecided-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IMMOBILIZER_REGISTRATION_START_REGISTRATION_IN_PROGRESS) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.igOn = false;
          ecuCounter = 1;
          this.endOfRegKey = false;
          this.clearWatcher();
          this.showDialogBoxes('modal-ecu-registration-completed-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_SYS_STATUS_FINISHED_KEY_REG_PROCESS) {
          this.igOn = false;
          ecuCounter = 1;
          this.endOfRegKey = false;
          this.clearWatcher();
          this.showDialogBoxes('modal-confirm-to-get-ignition-off-register-imb-system-type1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          this.processing = true;
        } else {
          this.processing = true;
        }
      } else {
        this.igOn = false;
        this.processing = false;
        this.endOfRegKey = false;
        ecuCounter = 1;
        this.clearWatcher();
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-register-imb-system-type1', error_msg);
      }

      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
      this.imbStatusInfo.current_program_status = getImbStatusResponse.current_program_status;
    },

    //calling IgOn api from register immobilizer system type1
    IgOnRegImbSysType1OkButtonClick: async function () {
      let error_msg = '';

      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_IMB_SYSTEM);
      error_msg = this.$t('imb.common_process_comm_with_biu');
      this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    //Calling notifyOkBtnAPI from register imb system type1
    onNotifyOkButtonPushedRegImbSysAPICall: async function () {
      await this.notifyOkBtnAPI(constants.IMB_NOTIFY_OK_BTN_PUSHED);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    //calling endOfKeyRegistration for register immobilizer system type1
    callendOfKeyRegistrationRegImbSysType1: async function () {
      this.hideWrap();
      this.processing = true;
      this.buttonPushStatus = this.imbStatusInfo.current_program_status;
      this.isButtonPush = true;
      await this.endOfKeyRegistration();
      let error_msg = '';
      error_msg = this.$t('imb.register_immobilizer_system_processing_imb_system_reg');
      this.showDialogBoxes('modal-process-is-going-on-register-imb-system-type1', error_msg);
    },

    // Register Immobilizer System type 2

    startRegType2OnConfirmOkButtonclick: async function () {
      this.processing = true;
      this.hideWrap();
      this.processNumber = constants.REGISTER_IMB_SYSTEM_TYPE_2_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_IMMOBILIZER_SYSTEM, constants.IMB_START_REGISTRAION_REGISTER_IMB_SYSTEM);
    },

    // 指摘内容は1関数の最大複雑度（20）と最大行数（50行）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity, max-statements */
    imbRegIMBSysType2Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (this.imbStatusInfo.imb_status === constants.IMB_NET_APP_IMOBI_PROGRESS) {
        return;
      }

      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_EGI && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTER_EGI;
      } else if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTERING;
      } else if (getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (this.isButtonPush) {
        if (this.buttonPushStatus === getImbStatusResponse.current_program_status) {
          return;
        } else {
          this.isButtonPush = false;
        }
      }

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('register-imb-sys-type-2-confirm-igon-required', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          this.showDialogBoxes('register-imb-sys-type-2-warning-ig-not-on', error_msg);
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          if (getImbStatusResponse.num_of_registered_keys > 0) {
            if (this.vehicleType === "E") {
              this.showDialogBoxes('register-imb-sys-type-e-confirm-igon-with-existing-key', error_msg);
            } else {
              error_msg = this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
              this.showDialogBoxes('register-imb-sys-type-2-confirm-igon-with-existing-key', error_msg);
            }
          } else {
            if (this.vehicleType === "B2" || this.vehicleType === "G") {
              error_msg = this.$t('imb.register_immobilizer_system_igni_on_switch_key_to_be_reg');
            } else if (this.vehicleType === "E") {
              error_msg = this.$t('imb.register_immobilizer_system_igni_on_switch_key_to_be_reg_type_e');
            } else if (this.vehicleType === "I") {
              error_msg = this.$t('imb.register_immobilizer_system_igni_on_switch_key_to_be_reg_imb');
            }
            this.showDialogBoxes('register-imb-sys-type-2-confirm-igon-with-given-key', error_msg);
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTER_EGI) {
          error_msg = this.$t('imb.common_processing_comm_with_ecm_reg');
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ADD_KEY_MODE_MATCHING_KEY_MATCHING) {
          error_msg = this.$t('imb.register_immobilizer_system_process_key_id');
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ADD_KEY_MODE_MATCHING_KEY_END) {
          this.showDialogBoxes('register-imb-sys-type-2-confirm-key-identification-establish', error_msg);
          if (this.endOfRegKey) {
            this.endOfRegKey = false;
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_REGISTERING) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_key_reg');
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTRATION_REGISTERED) {
          error_msg = this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-confirm-key-already-registered', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_COMPLETE_REGISTER_LIMIT) {
          error_msg = this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-confirm-max-no-of-registered-keys', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_REGISTRATION_AVAILABLE && getImbStatusResponse.current_program_status === constants.IMB_STATUS_KEY_REGISTRATION_COMPLETE_REGISTER) {
          error_msg = this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
          if (this.vehicleType === 'E') {
            this.showDialogBoxes('register-imb-sys-type-2-confirm-key-has-been-registered', error_msg);
          } else if (getImbStatusResponse.num_of_registered_keys > 0) {
            this.showDialogBoxes('register-imb-sys-type-2-confirm-key-has-been-registered', error_msg);
          } else {
            return;
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ALL_KEY_MATCHING_READING) {
          error_msg = this.$t('imb.register_immobilizer_system_processing_confirm_key_id');
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-confirm-key-identification', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ALL_KEY_MATCHING_MATCHING) {
          error_msg = this.$t('imb.register_immobilizer_system_process_key_id');
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ALL_KEY_MATCHING_READ_OUT) {
          error_msg = this.$t('imb.register_immobilizer_system_num_key_not_read', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-confirm-key-has-already-been-read', error_msg);
          if (this.endOfRegKey) {
            this.endOfRegKey = false;
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ALL_KEY_MATCHING_READ_COMPLETE) {
          error_msg = this.$t('imb.register_immobilizer_system_num_key_not_read', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-confirm-key-confirmed', error_msg);

          if (this.endOfRegKey) {
            this.endOfRegKey = false;
          }
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.igOn = false;
          ecuCounter = 1;
          error_msg = this.$t('imb.register_immobilizer_system_success_imb_system_reg') + '</br>' + this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
          this.clearWatcher();
          this.showDialogBoxes('register-imb-sys-type-2-success', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING && getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION) {
          if (this.vehicleType === "B2" || this.vehicleType === "G") {
            error_msg = this.$t('imb.common_process_comm_with_biu');
          } else if (this.vehicleType === "E" || this.vehicleType === "I") {
            error_msg = this.$t('imb.common_process_comm_with_imb_cm');
          }
          this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING) {
          if (this.vehicleType === "E") {
            error_msg = this.$t('imb.register_immobilizer_system_e_processing_imb_system_reg');
            this.showDialogBoxes('register-imb-sys-e-only-process-is-ongoing', error_msg);
          } else {
            error_msg = this.$t('imb.register_immobilizer_system_processing_imb_system_reg');
            this.showDialogBoxes('register-imb-sys-type-2-process-is-ongoing-com-BIU', error_msg);
          }
        } else {
          this.processing = true;
        }
      } else {
        this.igOn = false;
        this.clearWatcher();
        ecuCounter = 1;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_NUMBER_OF_REGISTERED_KEYS_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name)) + '</br>' + this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.IMB_NUM_OF_REGISTERED_KEYS_EXCEEDED) {
          if (this.vehicleType === 'E') {
            error_msg = this.$t('imb.error_number_of_key_registrations_exceeded_e', [getImbStatusResponse.num_of_registered_keys]);
          } else {
            error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
          }
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.IMB_KEY_REG_UNSUCCESSFUL_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else if (getImbStatusResponse.error_code === error.ERROR_COMBINATION_METER_SECURITY_CM_IS_NOT_COMPLETED) {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
          this.showDialogBoxes('modal-register-immobilizer-type2-warning', error_msg);
        } else if (getImbStatusResponse.error_code === error.ERROR_COMBINATION_METER_SECURITY_CM_REGISTRATION_FAILURE) {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
          this.showDialogBoxes('modal-register-immobilizer-type2-warning', error_msg);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        } else {
          this.clearWatcher();
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
          this.showDialogBoxes('register-imb-sys-type-2-failure', error_msg);
        }
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
      this.imbStatusInfo.current_program_status = getImbStatusResponse.current_program_status;
    },

    imbRegImbSysType2confirmOKOrRetryButtonClick: async function () {
      this.hideWrap();
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_IMB_SYSTEM);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    callEndOfKeyRegOnOkButtonClick: async function () {
      this.hideWrap();
      this.processing = true;
      this.buttonPushStatus = this.imbStatusInfo.current_program_status;
      this.isButtonPush = true;
      this.imbStatusInfo.imb_status = constants.IMB_NET_APP_IMOBI_PROGRESS;
      await this.endOfKeyRegistration();
      this.imbStatusInfo.imb_status = "";
    },

    onErrornotifyEndOfProcessRegImbSys: async function () {
      this.processing = true;
      if (this.processNumber === constants.REGISTER_IMB_SYSTEM_TYPE_1_PROCESS_NO) {
        await this.notifyEndOfProcess();
        this.showDialogBoxes('modal-confirm-to-get-ignition-off-register-imb-system-type1', '');
      } else if (this.processNumber === constants.REGISTER_IMB_SYSTEM_TYPE_2_PROCESS_NO) {
        this.hideWrap();
        await this.notifyEndOfProcess();
        if (this.imbStatusInfo.error_code !== error.IMB_NUM_OF_REGISTERED_KEYS_EXCEEDED) {
          this.showDialogBoxes('register-imb-sys-type-2-confirm-ig-is-off', '');
        }
      }
      this.processing = false;
    },
    onErrorNotifyEndOfProcessTelematicsCuType2: async function () {
      await this.notifyEndOfProcess();
      this.showDialogBoxes('modal-confirm-to-get-ignition-off-telematics-cm-registration-type2', '');
    },

    backEventOnCancleButtonClick: async function () {
      this.hideWrap();
      this.igOn = false;
      this.clearWatcher();
      await this.notifyEndOfProcess();
      this.processing = false;
    },

    // Register Immobilizer System type 3 (keyless)

    onClickGetRegisterKeylessImb: function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      this.showDialogBoxes('modal-confirm-to-start-keyless-access-immobilizer-registration-regKeylessImbType3', '');
    },

    //register keyless immobilizer confirmation ok button click
    registerKeyLessImbOkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_KEYLESS_IMB_SYSTEM_TYPE_3_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_KEYLESS_IMMOBILIZER, constants.IMB_START_REGISTRAION_REGISTER_KEYLESS_IMB_SYSTEM);
    },

    // 指摘内容は1関数の最大複雑度（20）と最大行数（50行）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity, max-statements */
    imbRegKeylessIMBSysType3Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      let value = 0;
      if (this.imbStatusInfo.imb_status === constants.IMB_NET_APP_IMOBI_PROGRESS) {
        return;
      }
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        if (getImbStatusResponse.imb_complete === true) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTERING;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTER_LIMIT) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTER_LIMIT;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_TRANSITIONING_REGISTRATION_MODE && getImbStatusResponse.display_code === "") {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_TRANSITIONING_REGISTRATION_MODE;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_CHECKING_CODE && getImbStatusResponse.display_code === "") {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_CHECKING_CODE;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_CHECKING_OWNER_TYPE2) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_CHECKING_OWNER_TYPE2;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_CHECKING_OWNER) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_CHECKING_OWNER;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING_ACCESS_KEY) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTERING_ACCESS_KEY;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_IMOBI_IGNITION_OFF) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_IMOBI_IGNITION_OFF;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_IMOBI_IGNITION_ON) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_IMOBI_IGNITION_ON;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTER_ECU) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTER_EGI;
        } else if (getImbStatusResponse.current_program_status === STATUS.REGISTER_HVECU) {
          getImbStatusResponse.imb_status = STATUS.REGISTER_HVECU;
        }
      }

      if (this.isButtonPush) {
        if (this.buttonPushStatus === getImbStatusResponse.current_program_status) {
          return;
        } else {
          this.isButtonPush = false;
        }
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_TRANSITIONING_REGISTRATION_MODE) {
          error_msg = this.$t('imb.register_key_less_immobilizer_process_comm_with_keyless_access_cm_and_ssm');
          this.showDialogBoxes('modal-process-is-going-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_CODE) {
          error_msg = this.$t('imb.register_key_less_immobilizer_process_checking_id_code');
          this.showDialogBoxes('modal-process-is-going-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_ACCESS_CM_REGISTRATION) {
          this.$pauseInterval(this.watcher);
          error_msg = this.$t('imb.register_key_less_immobilizer_exec_keyless_access_cm_reg');
          this.showDialogBoxes('modal-confirm-to-execute-keyless-access-CM-registration-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_ACCESS_IMB_REGISTRATION) {
          this.$pauseInterval(this.watcher);
          error_msg = this.$t('imb.register_key_less_immobilizer_exec_keyless_access_imb_reg');
          this.showDialogBoxes('modal-confirm-to-execute-keyless-access-CM-registration-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_OWNER_TYPE2) {
          value = (getImbStatusResponse.num_of_registered_keyless_access_keys);
          error_msg = this.$t('imb.register_key_less_immobilizer_num_access_key_read', [value]);
          this.showDialogBoxes('modal-the-proper-access-keys-should-be-confirmed-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_OWNER) {
          this.showDialogBoxes('modal-checking-owner-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys + getImbStatusResponse.collated_key_num;
          error_msg = this.$t('imb.common_num_reg_keys_with_format', [value]);
          this.showDialogBoxes('modal-accessKey-registering-regKeylessImbType3', error_msg);//quit button
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTER_LIMIT) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-accessKey-registerlimit-regKeylessImbType3', error_msg);//ok button
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING_ACCESS_KEY) {
          error_msg = this.$t('imb.register_key_less_immobilizer_process_access_keys_reg');
          this.showDialogBoxes('modal-process-is-going-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IMOBI_IGNITION_OFF) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys;
          error_msg = this.$t('imb.register_key_less_immobilizer_igni_off_push_button') + '</br></br>' + this.$t('imb.register_key_less_immobilizer_num_reg_access_keys', [value]);
          this.showDialogBoxes('modal-ignition-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IMOBI_IGNITION_ON) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys;
          error_msg = this.$t('imb.register_key_less_immobilizer_igni_on_with_reg_access_key') + '</br>' + this.$t('imb.register_key_less_immobilizer_num_reg_access_keys', [value]);
          this.showDialogBoxes('modal-ignition-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTER_EGI) {
          error_msg = this.$t('imb.register_key_less_immobilizer_process_ecm_reg');
          this.showDialogBoxes('modal-process-is-going-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === STATUS.REGISTER_HVECU) {
          error_msg = this.$t('imb.register_key_less_immobilizer_process_hvecu_reg');
          this.showDialogBoxes('modal-process-is-going-on-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.igOn = false;
          this.endOfRegKey = false;
          this.clearWatcher();
          this.showDialogBoxes('modal-success-regKeylessImbType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          this.processing = true;
        } else {
          this.processing = true;
        }
      } else {
        this.igOn = false;
        this.endOfRegKey = false;
        this.processing = false;
        this.clearWatcher();
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isShowNumberOfRegisteredAccessKeys(getImbStatusResponse.error_code)) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys;
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code) + '</br></br>' +
            this.$t('imb.register_key_less_immobilizer_num_reg_access_keys', [value]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regKeylessImbType3', error_msg);
      }

      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
      this.imbStatusInfo.current_program_status = getImbStatusResponse.current_program_status;

    },

    callRegKeylessImbEndOfKeyRegistraion: async function () {
      this.processing = true;
      this.buttonPushStatus = this.imbStatusInfo.current_program_status;
      this.isButtonPush = true;
      this.imbStatusInfo.imb_status = constants.IMB_NET_APP_IMOBI_PROGRESS;
      await this.endOfKeyRegistration();
      this.imbStatusInfo.imb_status = "";
      this.$resumeInterval(this.watcher);
    },

    // Register remote engine start cu

    //display Confirmation dialog box based on type
    onClickRegisterRemoteEngineStartCUButton: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B1") {
        this.showDialogBoxes('modal-confirm-to-start-regRemoteEngineStartCUType1', '');
      } else if (this.vehicleType === "B2" || this.vehicleType === "E" || this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('modal-confirm-to-start-regRemoteEngineStartCUType2', '');
      } else if (["D", "H1", "H2", "J"].includes(this.vehicleType)) {
        this.showDialogBoxes('modal-confirm-to-start-regRemoteEngineStartCUType3', '');
      }
    },

    // register remote engine start cu type 1

    onClickOkButtonRegRemoteEngineStartCUType1: async function () {
      this.processNumber = constants.REMOTE_ENGINE_START_CU_TYPE_1_PROCESS_NO;
      this.hideWrap();
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_REMOTE_ENGINE_START_CU, constants.IMB_START_REGISTER_REMOTE_ENGINE_START_CU);
    },

    callIGONAPIOnOkButtonClick: async function (id1, id2) {
      let error_msg = '';
      error_msg = this.$t('imb.common_process_comm_with_biu');
      this.showDialogBoxes(id2, error_msg);
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_REMOTE_ENGINE_START_CU);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    imbRegRemoteEngineStartCUType1Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_REGISTERING_REMOTE_START && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      } else if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_REGISTERING_REMOTE_START && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_PROCESSING;
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-regRemoteEngineStartCUType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REMOTE_ENIGINE_START_REGISTRATION_IN_PROGRESS) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('modal-process-is-going-on-regRemoteEngineStartCUType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          error_msg = this.$t('imb.register_remote_engine_start_cu_process_remote_engine_start_cm_reg');
          this.showDialogBoxes('modal-process-is-going-on-regRemoteEngineStartCUType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.showDialogBoxes('modal-remote-engine-start-cu-registration-completed-regRemoteEngineStartCUType1', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        //Switching process according to the error_code 
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regRemoteEngineStartCUType1', error_msg);
      }

      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    errorOkButtonClick: async function (id1, id2) {
      this.processing = true;
      this.hideWrap();
      await this.postCancelOnButtonClick();
      this.showDialogBoxes(id2, this.imbStatusInfo.error_message);
      this.igOn = false;
      this.clearWatcher();
      this.processing = false;
    },

    // register remote engine start cu type 2

    onClickOkButtonRegRemoteEngineStartCUType2: async function () {
      this.processNumber = constants.REMOTE_ENGINE_START_CU_TYPE_2_PROCESS_NO;
      this.hideWrap();
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_REMOTE_ENGINE_START_CU, constants.IMB_START_REGISTER_REMOTE_ENGINE_START_CU);
    },

    imbRegRemoteEngineStartCUType2Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      this.igOn = false;
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-retry-regRemoteEngineStartCUType2', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          error_msg = this.$t('imb.common_cannot_detect_igni_on');
          this.showDialogBoxes('modal-warning-key-not-found-regRemoteEngineStartCUType2', error_msg);
          ecuCounter = ecuCounter + 1;
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEYS_NOT_REGISTERED) {
          this.clearWatcher();
          error_msg = this.$t('imb.common_num_reg_key_perform_imb_system_reg');
          this.showDialogBoxes('modal-warning-key-not-found-regRemoteEngineStartCUType2', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-regRemoteEngineStartCUType2', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          ecuCounter = 1;
          this.showDialogBoxes('modal-success-regRemoteEngineStartCUType2', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
          if (this.vehicleType === "B2" || this.vehicleType === "G") {
            error_msg = this.$t('imb.common_process_comm_with_biu');
          } else {
            error_msg = this.$t('imb.common_process_comm_with_imb_cm');
          }
          this.showDialogBoxes('modal-process-is-going-on-regRemoteEngineStartCUType2', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        ecuCounter = 1;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regRemoteEngineStartCUType2', error_msg);
      }

      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    onClickRetryOrOkButtonCallIGONAPIRegRemoteEngineStartCuType2: async function () {
      let error_msg = '';
      if (this.vehicleType === "B2" || this.vehicleType === "G") {
        error_msg = this.$t('imb.common_process_comm_with_biu');
      } else {
        error_msg = this.$t('imb.common_process_comm_with_imb_cm');
      }
      this.imbStatusInfo =
      {
        error_message: error_msg
      };
      this.hideWrap();
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_REMOTE_ENGINE_START_CU);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    // register remote engine start cu type 3

    //on OK button click from register remote engine start cu type3
    onClickOkButtonRegRemoteEngineStartCUType3: async function () {
      this.processNumber = constants.REMOTE_ENGINE_START_CU_TYPE_3_PROCESS_NO;
      this.hideWrap();
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_REMOTE_ENGINE_START_CU, constants.IMB_START_REGISTRATION_REMOTEENGINE_STARTREGISTRATION_KEYLESS);
    },

    imbRegRemoteEngineStartCUType3Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING_REMOTE_START && getImbStatusResponse.imb_complete === false && getImbStatusResponse.error_code === error.SUCCESS) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_REGISTERING_REMOTE_START;
      } else if (getImbStatusResponse.imb_complete === true && getImbStatusResponse.error_code === error.SUCCESS) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      // Checking executing/success/failed status
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_REGISTERING_REMOTE_START) {
          error_msg = this.$t('imb.register_remote_engine_start_cu_process_remote_engine_start_cm_reg');
          this.showDialogBoxes('modal-process-is-going-on-regRemoteEngineStartCUType3', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.showDialogBoxes('modal-registration-completed-regRemoteEngineStartCUType3', error_msg);
        } else {
          if (["H1", "H2", "J"].includes(this.vehicleType)) {
            error_msg = this.$t('imb.common_initializing_comm');
            this.showDialogBoxes('modal-process-is-going-on-regRemoteEngineStartCUType3', error_msg);
          } else {
            this.processing = true;
          }
        }
      } else {
        this.clearWatcher();
        //Switching process according to the error_code  
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regRemoteEngineStartCUType3', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;

    },

    // Register Telematics cu

    //display Confirmation dialog box based on type
    onClickRegisterTelematicsCUButton: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B2" || this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('modal-confirm-telematics-cm-registration-type2', '');
      } else if (["D", "H1", "H2", "J"].includes(this.vehicleType)) {
        this.showDialogBoxes('register-Telematics-cu-type-3', '');
      }
    },

    // register Telematics cu type 2
    onClickOkButtonRegTelematicsCUType2: async function () {
      this.processNumber = constants.TELEMATICS_CU_TYPE_2_PROCESS_NO;
      this.hideWrap();
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_TELEMATICS_CU, constants.IMB_START_TELEMATICS_CU);
    },

    // 指摘内容は1関数の最大複雑度（20）と最大行数（50行）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity, max-statements */
    imbRegTelematicsCUType2Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      this.processing = false;
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_NUMBER_OF_REGISTER_KEYS) {
          this.processing = true;
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEYS_NOT_REGISTERED) {
          this.clearWatcher();
          error_msg = this.$t('imb.common_num_reg_key_perform_imb_system_reg');
          this.showDialogBoxes('modal-telematics-cm-registration-type2-warning', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-telematics-cm-registration-type2', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
          if (this.vehicleType === "B2" || this.vehicleType === "G") {
            error_msg = this.$t('imb.common_process_comm_with_biu');
          } else if (this.vehicleType === "I") {
            error_msg = this.$t('imb.common_process_comm_with_imb_cm');
          }
          this.showDialogBoxes('modal-process-is-going-on-telematics-cm-registration-type2', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          ecuCounter = 1;
          this.showDialogBoxes('modal-success-telematics-cm-registration-type2', error_msg);
        } else {
          if (this.vehicleType === "B2" || this.vehicleType === "G") {
            error_msg = this.$t('imb.common_process_comm_with_biu');
          } else if (this.vehicleType === "I") {
            error_msg = this.$t('imb.common_process_comm_with_imb_cm');
          }
          this.showDialogBoxes('modal-process-is-going-on-telematics-cm-registration-type2', error_msg);
        }
      } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-retry-telematics-cm-registration-type2', error_msg);
          ecuCounter++;
        } else {
          this.clearWatcher();
          error_msg = this.$t('imb.common_cannot_detect_igni_on');
          this.showDialogBoxes('modal-telematics-cm-registration-type2-warning', error_msg);
          ecuCounter = 1;
          this.updateImbEventLogIgOnFailed();
        }
      } else {
        this.clearWatcher();
        //Switching process according to the error_code  
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-telematics-cm-registration-type2-error', error_msg);
      }

      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;

    },

    onClickCallIgOnAPI: async function () {
      this.processing = true;
      await this.callingIGONAPI(constants.IMB_START_TELEMATICS_CU_IG_ON);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    // register Telematics cu type 3
    onClickOkButtonRegTelematicsCUType3: async function () {
      this.processNumber = constants.TELEMATICS_CU_TYPE_3_PROCESS_NO;
      this.hideWrap();
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_TELEMATICS_CU, constants.IMB_START_TELEMATICS_CU_KEYLESS);
    },

    imbRegTelematicsCUType3Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING_TELEMATICS && getImbStatusResponse.imb_complete === false) {
          error_msg = this.$t('imb.register_telematics_cu_protelematics_cm_reg');
          this.showDialogBoxes('register-Telematics-cu-type-3-process-is-ongoing-telematics-cm-register', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_REGISTERING_TELEMATICS && getImbStatusResponse.imb_complete === true) {
          this.clearWatcher();
          this.processing = false;
          this.showDialogBoxes('register-Telematics-cu-type-3-success', error_msg);
        } else {
          if (["H1", "H2", "J"].includes(this.vehicleType)) {
            error_msg = this.$t('imb.common_initializing_comm');
            this.showDialogBoxes('register-Telematics-cu-type-3-process-is-ongoing-telematics-cm-register', error_msg);
          } else {
            this.processing = true;
          }
        }
      } else {
        this.clearWatcher();
        //Switching process according to the error_code 
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('register-Telematics-cu-type-3-failure', error_msg);
      }

      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    // common function for processing switch
    changeProcessingStatus(bool) {
      this.processing = bool;
    },

    //  common function for show hide dialogBox
    showWrap: function (dialogId) {
      // ダイアログ表示の場合は、必ず processing を false にする
      this.processing = false;
      this.modalShowInfo = { id: dialogId, isShow: true };
    },

    hideWrap: function (showid, msg) {
      if (showid) {
        this.modalShowInfo = { id: this.dialog_id, isShow: false, nextModal: { id: showid, message: msg } };
      } else {
        this.modalShowInfo = { id: this.dialog_id, isShow: false };
      }
    },

    handleShow: function (mode) {
      // showされた場合に実行する処理
      if (!mode.isShow) {
        this.dialog_id = '';
        this.dialog_visible = false;
        if (mode.nextModal) {
          this.imbStatusInfo.error_message = mode.nextModal.message;
          this.showWrap(mode.nextModal.id);
        }
      }
      else {
        this.dialog_id = mode.id;
        this.dialog_visible = mode.isShow;
      }
    },

    showDialogBoxes: function (showid, msg) {
      if (this.dialog_visible) {
        if (this.dialog_id !== showid || this.imbStatusInfo.error_message !== msg) {
          this.hideWrap(showid, msg);
        }
      } else {
        this.showWrap(showid);
        this.imbStatusInfo.error_message = msg;
      }
    },

    //validating api result

    validation: async function (result) {
      const cause = result.causeType;
      const behaviorType = result.behaviorType;
      // Logout if session is invalid or network error
      if (cause === handler.causeTypes.networkError ||
        cause === handler.causeTypes.invalidSessionToken) {
        this.clearWatcher();
        alert.showWarning(this, null, result.message, () => {
          if (behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          } else if (behaviorType === handler.behaviorTypes.resetSession) {
            this.resetSession(this);
          }
        });
      } else {
        // Other errors
        this.showUnexpectedErrorModal(result.message);
      }
      this.processing = false;
      return;
    },

    // Register Central Gateway

    // Register Central Gateway Type 2

    onRegisterCentralGateway: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('register-central-gateway-type-2-confirm-start', '');
      }
    },

    onRegCentralGateway2OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_CENTRAL_GATEWAY_TYPE_2_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_CENTRAL_GATEWAY, constants.IMB_START_REGISTER_CENTRAL_GATEWAY);
    },

    // 指摘内容は1関数の最大複雑度（20）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity */
    imbRegCentralGatewayType2Process: async function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';

      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('register-central-gateway-type-2-confirm-ig-is-on', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          this.showDialogBoxes('register-central-gateway-type-2-warning-ig-on', error_msg);
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEYS_NOT_REGISTERED) {
          this.clearWatcher();
          this.showDialogBoxes('register-central-gateway-type-2-warning-key-not-found', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('register-central-gateway-type-2-confirm-igon', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('register-ECU-type-2-progress-comm-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.processing = false;
          error_msg = '';
          this.showDialogBoxes('register-central-gateway-type-2-success', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          this.processing = true;
        } else {
          if (this.vehicleType === "G") {
            error_msg = this.$t('imb.common_process_comm_with_biu');
          } else if (this.vehicleType === "I") {
            error_msg = this.$t('imb.common_process_comm_with_imb_cm');
          }
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('register-central-gateway-type-2-failure', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    callIGONAPIOnClickOkOrRetryButton: async function () {
      let error_msg = '';
      let urlendpoint = '';
      this.hideWrap();
      if (this.processNumber === constants.DELETE_ID_OF_IMB_KEY_TYPE_2_PROCESS_NO) {
        if (this.vehicleType === "G" || this.vehicleType === "B2") {
          error_msg = this.$t('imb.common_process_comm_with_biu');
        } else if (this.vehicleType === "I" || this.vehicleType === "E") {
          error_msg = this.$t('imb.common_process_comm_with_imb_cm');
        }
        urlendpoint = constants.IMB_IGON_DELETE_IMB_ID_KEY;
      }
      if (this.processNumber === constants.REGISTER_CENTRAL_GATEWAY_TYPE_2_PROCESS_NO) {
        if (this.vehicleType === "G") {
          error_msg = this.$t('imb.common_process_comm_with_biu');
        } else if (this.vehicleType === "I") {
          error_msg = this.$t('imb.common_process_comm_with_imb_cm');
        }
        urlendpoint = constants.IMB_IGON_REGISTER_CENTRAL_GATEWAY;
      }
      this.imbStatusInfo =
      {
        error_message: error_msg
      };
      await this.callingIGONAPI(urlendpoint);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    onErrorOkButtonClick: async function (id1, id2) {
      this.processing = true;
      this.igOn = false;
      this.hideWrap();
      await this.notifyEndOfProcess();
      this.showDialogBoxes(id2, this.imbStatusInfo.error_message);
      this.processing = false;
    },

    // Delete Id of Immobilizer Key

    onDeleteIdOfImbKeyButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B1") {
        this.showDialogBoxes('modal-confirm-to-start-deleteIdOfImbKeyType1', '');
      } else if (this.vehicleType === "B2" || this.vehicleType === "E" || this.vehicleType === "G" || this.vehicleType === "I") {
        this.showDialogBoxes('delete-id-of-imb-key-type-2-confirm-to-start', '');
      }
    },

    //  New api call

    sendCheckNumOfKeys: async function () {
      this.processing = true;
      this.igOn = true;
      const token = session.getToken();
      try {
        const startImbResponse = await api.postCall(config.IMB, '/sendCheckNumOfKeys/' + this.netAppId, {
          id_token: token.id_token,
        });
        const isSuccess = handler.validate(handler.validateTypes.all, startImbResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.processing = false;
          return;
        }
        // Start imb status monitoring
        this.$resumeInterval(this.watcher);

      } catch (error) {
        this.processing = false;
      }
    },

    notifyStartKeyDeletionProcess: async function () {
      this.processing = true;
      const token = session.getToken();
      try {
        const startImbResponse = await api.postCall(config.IMB, '/deleteIdOfImmobilizerkeystartDeleteProcess/' + this.netAppId, {
          id_token: token.id_token,
        });
        const isSuccess = handler.validate(handler.validateTypes.all, startImbResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.processing = false;
          return;
        }
      } catch (error) {
        this.processing = false;
      }
    },

    // Delete Id of Immobilizer key Type 1

    onDeleteIdOfImbKeyType1OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.DELETE_ID_OF_IMB_KEY_TYPE_1_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_DELETE_IMMOBILIZER_KEY_ID, constants.IMB_START_DELETE_KEYS);
    },

    imbDeleteIdOfImbKeyType1Process: async function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_ERASING_KEY_ID && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      } else if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_ERASING_KEY_ID && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_ERASING_KEY_ID;
      }
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on1-deleteIdOfImbKeyType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_KEY_REMOVAL) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on2-deleteIdOfImbKeyType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ERASING_KEY_ID) {
          this.showDialogBoxes('modal-process-is-going-on2-deleteIdOfImbKeyType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          this.showDialogBoxes('modal-success-deleteIdOfImbKeyType1', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-deleteIdOfImbKeyType1', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    onDeleteIdOfImbKeyType1IgOn2OkButtonClick: async function () {
      await this.notifyStartKeyDeletionProcess();
      this.showDialogBoxes('modal-process-is-going-on1-deleteIdOfImbKeyType1', '');
      // Start imb status monitoring
      this.$resumeInterval(this.watcher);
    },

    // Delete id Immobilizer key type 2

    onDeleteIdOfImbKey2OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.DELETE_ID_OF_IMB_KEY_TYPE_2_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_DELETE_IMMOBILIZER_KEY_ID, constants.IMB_START_DELETE_KEYS);
    },

    // 指摘内容は1関数の最大複雑度（20）と最大行数（50行）の超過であるため、処理内容自体の問題はないと判断。
    /* eslint-disable-next-line complexity, max-statements */
    imbDeleteIdOfImbKeyType2Process: async function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      let value = 0;
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('delete-id-of-imb-key-type-2-confirm-ig-is-on', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          this.showDialogBoxes('delete-id-of-imb-key-type-2-warning-ig-on', error_msg);
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_CANNOT_DELETE_ANYMORE) {
        this.processing = false;
        this.clearWatcher();
        this.showDialogBoxes('delete-id-of-imb-key-type-2-warning-cannot-delete-key-anymore', error_msg);
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEY_NOT_FOUND) {
          this.clearWatcher();
          this.showDialogBoxes('delete-id-of-imb-key-type-2-warning-key-not-found', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('delete-id-of-imb-key-type-2-confirm-igon', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_DELETE_ID_OF_IMMOBILIZER_KEY_IN_PROGRESS) {
          this.showDialogBoxes('delete-id-of-imb-key-type-2-progress-comm-BIU', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('register-ECU-type-2-progress-comm-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          if (this.vehicleType === "G" || this.vehicleType === "B2" || this.vehicleType === "I") {
            error_msg = '';
          }
          else if (this.vehicleType === "E") {
            value = getImbStatusResponse.num_of_registered_keys;
            error_msg = this.$t('imb.common_num_reg_keys_with_format', [value]);
          }
          this.showDialogBoxes('delete-id-of-imb-key-type-2-success', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_NUMBER_OF_REGISTERED_KEYS_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name)) + '</br>' + this.$t('imb.common_num_reg_keys_without_unit', [getImbStatusResponse.num_of_registered_keys]);
        } else if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else {
          if (this.vehicleType === "G" || this.vehicleType === "B2" || this.vehicleType === "I") {
            if (getImbStatusResponse.error_code === error.IMB_KEY_DELETION_ERROR) {
              error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
            } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
              const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
              error_cause_msg = this.$t(causeAndAction.err_cause);
              error_action_msg = this.$t(causeAndAction.err_action);
            } else {
              error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
            }
          } else if (this.vehicleType === "E") {
            if (getImbStatusResponse.error_code === error.IMB_KEY_DELETION_ERROR) {
              error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keys]);
            } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
              const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
              error_cause_msg = this.$t(causeAndAction.err_cause);
              error_action_msg = this.$t(causeAndAction.err_action);
            } else {
              error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
            }
          }
        }
        this.showDialogBoxes('delete-id-of-imb-key-type-2-failure', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    // Delete id Immobilizer key type 3
    onDeleteIdOfAccessKeyButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      this.showDialogBoxes('delete-id-of-imb-key-type-3-confirm-to-start', '');
    },

    onDeleteIdOfImbKey3OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.DELETE_ID_OF_ACCESS_KEY_TYPE_3_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_DELETE_ACCESS_KEY_ID, constants.IMB_START_DELETION);
    },

    imbDeleteIdOfImbKeyType3Process: async function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      let value = 0;
      // Checking executing/success/failed status
      if (getImbStatusResponse.error_code === error.SUCCESS) {
        if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_ERASING_KEY_ID && getImbStatusResponse.imb_complete === false) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_ERASING_KEY_ID;
        } else if (getImbStatusResponse.imb_complete === true) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
        }
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_ERASING_KEY_ID) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys;
          error_msg = this.$t('imb.delete_access_key_id_key_less_num_access_key_registered') + " " + this.$t('imb.delete_access_key_id_key_less_num_access_key_num', [value]);
          this.showDialogBoxes('delete-id-of-imb-key-type-3-deletion-of-all-access-key-except-current', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          value = getImbStatusResponse.num_of_registered_keyless_access_keys;
          this.clearWatcher();
          error_msg = this.$t('imb.delete_access_key_id_key_less_imb_access_key_id_delete_ended') + '</br>' + this.$t('imb.delete_access_key_id_key_less_num_access_key_remaining', [value]);
          this.showDialogBoxes('delete-id-of-imb-key-type-3-success', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        //Switching process according to the error_code
        if (getImbStatusResponse.error_code === error.IMB_ONE_KEY_MUST_BE_REGISTERED) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.num_of_registered_keyless_access_keys]);
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('delete-id-of-imb-key-type-3-failure', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    // Register Steering Lock CU (type-3) 
    onRegSteeringLockCUType3ButtonClick: function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (["D", "H1", "H2", "J"].includes(this.vehicleType)) {
        this.showDialogBoxes('register-steering-lock-cu-type-3-confirm-to-start', '');
      }
    },

    onRegSteeringLockCUType3OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_STEERING_LOCK_CU_TYPE_3_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_STEERING_LOCK_CU, constants.IMB_START_REGISTER_STEERING_LOCK_CU);
    },

    imbRegSteeringLockCUType3Process: async function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS) {
        if (getImbStatusResponse.imb_complete === true) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_CHECKING_OWNER && getImbStatusResponse.imb_complete === false) {
          getImbStatusResponse.imb_status = constants.IMB_STATUS_CHECKING_OWNER;
        }
      }

      // Checking executing/success/failed status
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_OWNER) {
          this.showDialogBoxes('register-steering-lock-cu-type-3-confirm-the-proper-key', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          error_msg = this.$t('imb.register_steering_lock_cu_key_less_steering_lock_cm_reg_ended');
          this.showDialogBoxes('register-steering-lock-cu-type-3-success', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        //Switching process according to the error_code
        if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('register-steering-lock-cu-type-3-failure', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    // register combination meter

    //display Confirmation dialog box based on type
    onRegisterCombinationMeterButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (this.vehicleType === "B1") {
        this.showDialogBoxes('modal-confirm-regCombinationMeterType1', '');
      } else if (this.vehicleType === "B2") {
        this.showDialogBoxes('modal-confirm-regCombinationMeterType2', '');
      }
    },

    //IGON ok or Retry button click reg combination meter
    IgOnRegCombinationMeterOkOrRetryButtonClick: async function (id1, id2) {
      if (this.vehicleType === "B1") {
        this.showDialogBoxes(id2, this.$t('imb.common_process_comm_with_biu'));
      } else if (this.vehicleType === "B2") {
        this.hideWrap();
      }
      //call api-03 method
      await this.callingIGONAPI(constants.IMB_IG_ON_REGISTER_COMBINATION_METER);
      // Start IMB status monitoring
      this.$resumeInterval(this.watcher);
    },

    //register combination meter type1

    onRegCombinationMeterType1OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_COMBINATION_METER_TYPE_1_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_COMBINATION_METER, constants.IMB_START_REGISTRATION_REGISTER_COMBINATION_METER);
    },

    //Register Combination Meter Type1 GetStatus api response validation
    imbRegCombinationMeterType1Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_REGISTERING_COMBINATION_METER && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      } else if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.current_program_status === constants.IMB_REGISTERING_COMBINATION_METER && getImbStatusResponse.imb_complete === false) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_PROCESSING;
      }

      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-regCombinationMeterType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_VEHICLE_STATUS) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('modal-process-is-going-on-regCombinationMeterType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_PROCESSING) {
          error_msg = this.$t('imb.register_combination_meter_process_combination_meter');
          this.showDialogBoxes('modal-process-is-going-on-regCombinationMeterType1', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.showDialogBoxes('modal-ecu-registration-completed-regCombinationMeterType1', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.igOn = false;
        this.processing = false;
        this.clearWatcher();
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regCombinationMeterType1', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    //register combination meter type2
    onRegCombinationMeterType2OkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.REGISTER_COMBINATION_METER_TYPE_2_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_REGISTER_COMBINATION_METER, constants.IMB_START_REGISTRATION_REGISTER_COMBINATION_METER);
    },

    //Register Combination Meter Type2 GetStatus api response validation
    imbRegCombinationMeterType2Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      this.igOn = false;
      if (getImbStatusResponse.error_code === error.SUCCESS && getImbStatusResponse.imb_complete === true) {
        getImbStatusResponse.imb_status = constants.IMB_STATUS_COMPLETED;
      }

      if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGNITION_OFF && getImbStatusResponse.error_code === error.IMB_CANNOT_CONFIRM_IGON_ERROR) {
        this.processing = false;
        if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on2-regCombinationMeterType2', error_msg);
          ecuCounter = ecuCounter + 1;
        } else {
          this.clearWatcher();
          error_msg = this.$t('imb.common_cannot_detect_igni_on');
          this.showDialogBoxes('modal-warning-key-not-found-regCombinationMeterType2', error_msg);
          ecuCounter = ecuCounter + 1;
          this.updateImbEventLogIgOnFailed();
        }
      } else if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_KEYS_NOT_REGISTERED) {
          this.clearWatcher();
          error_msg = this.$t('imb.common_num_reg_key_perform_imb_system_reg');
          this.showDialogBoxes('modal-warning-key-not-found-regCombinationMeterType2', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_IGON_EXPECTED) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('modal-confirm-to-get-ignition-on-regCombinationMeterType2', error_msg);
        } else if (getImbStatusResponse.current_program_status === constants.IMB_STATUS_INITIALIZATION_COMMUNICATION && getImbStatusResponse.imb_complete === false) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('register-ECU-type-2-progress-comm-BIU', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETED) {
          this.clearWatcher();
          this.igOn = false;
          ecuCounter = 1;
          this.showDialogBoxes('modal-ecu-registration-completed-regCombinationMeterType2', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_CHECKING_THE_VEHICLE_STATUS) {
          error_msg = this.$t('imb.common_process_comm_with_biu');
          this.showDialogBoxes('modal-process-is-going-on-regCombinationMeterType2', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        this.processing = false;
        ecuCounter = 1;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('modal-err-failed-regCombinationMeterType2', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    /** イモビライザーリセットメニュー押下時処理 */
    onDeleteAllKeysButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: IMMOBILIZER });

      this.showDialogBoxes('delete-all-keys-confirm-otpw-input', '');
    },

    /** 
     * OTPW照合処理
     * @param {string} otpw ワンタイムパスワード
     */
    onDeleteAllKeysOkButtonPushedOtpwVerifyAPICall: async function (otpw) {
      this.processing = true;

      try {
        const startIMBResponse = await api.postCall(config.IMB, `${API_ENDPOINT.DELETE_ALL_KEY_AUTHENTICATION}` + this.netAppId, {
          otpw,
        });

        handler.validate(handler.validateTypes.all, startIMBResponse, this, null,
          () => {
            if (startIMBResponse?.data?.status === true) {
              this.showDialogBoxes('delete-all-keys-confirm-to-start', '');
            } else {
              this.showDialogBoxes('delete-all-keys-error-confirm-otpw', '');
            }
          },
          (result) => { this.validation(result); }, null, false);

      } catch (error) {
        // 'Unexpected error has occurred'
        this.showUnexpectedErrorModal(this.$t('imb.error_imb_system_cause'));
      } finally {
        this.processing = false;
      }
    },

    /** 全キー消去開始 */
    onDeleteAllKeysOkButtonClick: async function () {
      this.hideWrap();
      this.processing = true;
      ecuCounter = 1;
      this.processNumber = PROCESS.DELETE_ALL_KEYS.NUMBER;
      await this.createEventLogRecord(FUNCTION_NAME.DELETE_ALL_KEYS);
      await this.startDeleteAllKeysAPICall();
    },

    /** 全キー消去開始APIを呼び出す */
    startDeleteAllKeysAPICall: async function () {

      try {

        const token = session.getToken();

        const startDeleteAllKeyResponse = await api.postCall(config.IMB,
          (VEHICLE_TYPE.TYPE2.includes(this.vehicleType) ? `${API_ENDPOINT.START_DELETE_ALL_KEY2}` : `${API_ENDPOINT.START_DELETE_ALL_KEY3}`) + this.netAppId, {
          id_token: token.id_token,
        });

        const isSuccess = handler.validate(handler.validateTypes.all, startDeleteAllKeyResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);

        if (!isSuccess) {
          this.processing = false;
          return;
        }

        // Start IMB status monitoring
        await this.setupWatcher();

      } catch (error) {
        // 'Unexpected error has occurred'
        this.processing = false;
        this.showUnexpectedErrorModal(this.$t('imb.error_imb_system_cause'));
      }
    },

    /** IGN-ON指示APIを呼び出す */
    igOnOkButtonPushedDeleteAllKeyIgOnAPICall: async function () {

      this.igOn = false;
      this.processing = true;

      try {
        const token = session.getToken();

        const deleteAllKeyIgOnResponse = await api.postCall(config.IMB, `${API_ENDPOINT.DELETE_ALL_KEY_IGON}` + this.netAppId, {
          id_token: token.id_token,
        });

        const isSuccess = handler.validate(handler.validateTypes.all, deleteAllKeyIgOnResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);

        if (!isSuccess) {
          this.processing = false;
          return;
        }

        this.igOn = true;
        // Start IMB status monitoring
        this.$resumeInterval(this.watcher);

      } catch (error) {
        // 'Unexpected error has occurred'
        this.processing = false;
        this.showUnexpectedErrorModal(this.$t('imb.error_imb_system_cause'));
      }
    },

    /** 全キー消去キャンセルAPIを呼び出す */
    onDeleteAllKeyCancelAPICall: async function () {

      this.processing = true;

      try {
        const deleteAllKeyCancelResponse = await api.postCall(config.IMB, `${API_ENDPOINT.DELETE_ALL_KEY_CANCEL}` + this.netAppId, {});

        const isSuccess = handler.validate(handler.validateTypes.all, deleteAllKeyCancelResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);

        if (!isSuccess) {
          this.processing = false;
          return;
        }

        // Start IMB status monitoring
        this.$resumeInterval(this.watcher);

      } catch (error) {
        // 'Unexpected error has occurred'
        this.processing = false;
        this.showUnexpectedErrorModal(this.$t('imb.error_imb_system_cause'));
      }
    },

    /** 
     * 全キー消去処理ステータスに応じて処理を行う
     * @param {object} getImbStatusResponse IMBステータスAPI応答
     */
    imbDeleteAllKeysProcess: function (getImbStatusResponse) {

      let errorMsgText = '';
      let errorCauseMsg = '';
      let errorActionMsg = '';

      // ① 進行状態で検索
      let found = IMB_DELETE_ALL_KEYS_PROGRESS_LIST.find(item =>
        item.errCode === getImbStatusResponse.error_code &&
        item.imbComplete === getImbStatusResponse.imb_complete &&
        item.imbStatus === getImbStatusResponse.imb_status
      );

      // ② エラー系で検索
      if (!found) {
        const errorConfig = IMB_DELETE_ALL_KEYS_ERROR_MAP[getImbStatusResponse.error_code];
        if (errorConfig) {
          found = { ...errorConfig, action: errorConfig.action || DELETE_ALL_KEYS_ACTION.NONE };
        }
      }

      if (found) {
        const action = found.action;
        let dialogId = found.dialogId;

        // actionに応じた処理の定義
        const deleteAllKeysActionHandler = {
          // ステータス監視を一時停止する
          PAUSE_WATCHER(context) {
            context.$pauseInterval(context.watcher);
          },

          // ステータス監視を停止し、全キー消去処理を終了する
          END_PROCESS(context) {
            context.clearWatcher();
          },

          // IGOFF状態時の処理
          // リトライ回数が上限未満の場合はステータス監視を一時停止→リトライ回数を加算→再IGN-ON指示確認ダイアログを表示する。
          // 上限に達した場合はステータス監視を停止→IGON失敗をイベントログに記録→IGON確認失敗ダイアログを表示する。
          IGOFF_ACTION(context) {
            if (ecuCounter < SWITCH_IG_ON_RETRY_COUNTER) {
              context.$pauseInterval(context.watcher);
              ecuCounter = ecuCounter + 1;
              dialogId = 'delete-all-keys-confirm-ig-is-on';
            } else {
              context.clearWatcher();
              context.updateImbEventLogIgOnFailed();
              dialogId = 'delete-all-keys-warning-ig-on';
            }
          },

          // スピナーを表示し続け、ステータス監視処理も継続する
          CONTINUE(context) {
            context.processing = true;
          }
        };

        if (action) {
          deleteAllKeysActionHandler[action]?.(this);
        }

        const numOfRegisteredKeys = getImbStatusResponse.num_of_registered_keys;
        this.imbStatusInfo.num_of_registered_keys = numOfRegisteredKeys;

        const errorMsgHandler = imbDeleteAllKeysError[getImbStatusResponse.error_code];
        if (errorMsgHandler) {
          errorMsgText = errorMsgHandler(getImbStatusResponse, this);
        }

        // CONTINUEアクションの場合はダイアログを表示せず、スピナーを維持して監視を継続する
        if (action !== DELETE_ALL_KEYS_ACTION.CONTINUE) {
          this.showDialogBoxes(dialogId, errorMsgText);
        }
      } else {
        // 全キー消去独自ではないイモビ登録機能共通のエラー処理
        this.clearWatcher();
        if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          errorCauseMsg = this.$t(causeAndAction.err_cause);
          errorActionMsg = this.$t(causeAndAction.err_action);
        } else {
          errorMsgText = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('delete-all-keys-failure', errorMsgText);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = errorCauseMsg;
      this.imbStatusInfo.error_action_message = errorActionMsg;
    },

    // get registration history 
    onGetRegistrationHistoryButtonClick: async function () {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_IMMOBILIZER);

      // イモビのカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_IMMOBILIZER });

      if (["D", "H1", "H2", "J"].includes(this.vehicleType)) {
        this.showDialogBoxes('get-registration-history-type-3-confirm-start-sequence', '');
      }
    },

    onGetRegistrationHistoryOkButtonClick: async function () {
      this.hideWrap();
      this.processNumber = constants.GET_REGISTRATION_HISTORY_TYPE_3_PROCESS_NO;
      await this.startRegistrationAndCreateLogRecord(constants.FUNCTION_NAME_GET_THE_REGISTRATION_HISTORY, constants.IMB_START_REGISTRATION_HISTORY);
    },

    // calling notifyOkBtn API
    notifyOkBtnPushedAPI: async function (endpoint, ok_flag) {
      try {
        const notifyIMBResponse = await api.postCall(config.IMB, `${endpoint}` + this.netAppId, { vehicle_type: this.vehicleType, okFlag: ok_flag });

        const isSuccess = handler.validate(handler.validateTypes.all, notifyIMBResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          return;
        }
        if (this.resumeIntr === true) {
          // Start imb status monitoring
          this.$resumeInterval(this.watcher);
        }
        this.resumeIntr = false;
      } catch (error) {
        //unexpected error
        this.resumeIntr = false;
      }
    },

    //get registration history type 3 start reading history

    imbGetRegistrationHistoryType3Process: function (getImbStatusResponse) {
      let error_msg = '';
      let error_msgs = '';
      let error_cause_msg = '';
      let error_action_msg = '';
      if (getImbStatusResponse.error_code === error.SUCCESS || getImbStatusResponse.error_code === "") {
        this.processing = false;
        if (getImbStatusResponse.imb_status === constants.IMB_STATUS_WAITING_FOR_OK_BUTTON_PRESSED && getImbStatusResponse.display_code === constants.IMB_DISPLAY_CODE_PREV_REG_HISTORY) {
          this.$pauseInterval(this.watcher);
          this.showDialogBoxes('get-registration-history-type-3-confirm-start-read-history', error_msg);
        } else if (getImbStatusResponse.imb_status === constants.IMB_STATUS_COMPLETE) {
          this.clearWatcher();
          if (getImbStatusResponse.reading_result_message === '-') {
            error_msg = "";
          } else {
            error_msg = this.$t(`imb.${getImbStatusResponse.reading_result_message}`);
          }
          if (getImbStatusResponse.detail_message_list.length === 0) {
            error_msgs = '';
          } else {
            const message = [];
            for (let i = 0; i < getImbStatusResponse.detail_message_list.length; i++) {
              message.push(this.$t(`imb.${getImbStatusResponse.detail_message_list[i]}`));
            }
            error_msgs = message.join('</br>');
          }
          this.showDialogBoxes('get-registration-history-type-3-display-regstration-history', error_msg);
        } else {
          this.processing = true;
        }
      } else {
        this.clearWatcher();
        //Switching process according to the error_code 
        this.igOn = false;
        this.processing = false;
        if (getImbStatusResponse.error_code === error.IOCP_RCID_COMMUNICATION_ERROR) {
          error_msg = this.$t(getErrorMessageKeyIocpRcidStatus(getImbStatusResponse.message, this.vehicleType, getImbStatusResponse.systems[0].system_name));
        } else if (getImbStatusResponse.error_code === error.IMB_SEQUENCE_NOT_FOUND) {
          error_msg = this.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
        } else if (getImbStatusResponse.error_code === error.IMB_ABNORMAL_TERMINATION_ERROR) {
          error_msg = this.$t((getErrorMessageKey(this, getImbStatusResponse.error_code, this.vehicleType)), [getImbStatusResponse.message]);
        } else if (this.isCausesAndActionDialog(getImbStatusResponse.error_code)) {
          const causeAndAction = getErrorMessageCauseAndAction(getImbStatusResponse.error_code);
          error_cause_msg = this.$t(causeAndAction.err_cause);
          error_action_msg = this.$t(causeAndAction.err_action);
        } else {
          error_msg = getErrorMessageKey(this, getImbStatusResponse.error_code);
        }
        this.showDialogBoxes('get-registration-history-type-3-failure', error_msg);
      }
      this.imbStatusInfo.systems = getImbStatusResponse.systems;
      this.imbStatusInfo.error_code = getImbStatusResponse.error_code;
      this.imbStatusInfo.error_messages = error_msgs;
      this.imbStatusInfo.imb_status = getImbStatusResponse.imb_status;
      this.imbStatusInfo.error_cause_message = error_cause_msg;
      this.imbStatusInfo.error_action_message = error_action_msg;
    },

    onRegHistoryCancelBtnClick: async function () {
      ok_flag = false;
      this.resumeIntr = false;
      this.hideWrap();
      await this.notifyOkBtnPushedAPI(constants.IMB_GET_REGISTRATION_HISTORY_NOTIFY_OK_BTN_PUSHED, ok_flag);
    },

    onRegHistoryOkBtnClick: async function () {
      this.processing = true;
      ok_flag = true;
      this.resumeIntr = true;
      this.hideWrap();
      await this.notifyOkBtnPushedAPI(constants.IMB_GET_REGISTRATION_HISTORY_NOTIFY_OK_BTN_PUSHED, ok_flag);
    },

    onFinishOkBtnClick: async function () {
      ok_flag = true;
      this.resumeIntr = false;
      this.hideWrap();
      await this.notifyOkBtnPushedAPI(constants.IMB_GET_REGISTRATION_HISTORY_NOTIFY_OK_BTN_PUSHED, ok_flag);
    },

    displayVehicleTypeWithFormatting: function () {
      // Remove number part from vehicle type and display only the alphabet
      this.vehicleTypeDisplayText = this.vehicleType.replace(/\d+/g, '');
    },

    // 処理完了フラグを設定する
    onSetEndOfProcessingFlag: function (value = true) {
      if (this.endOfProcessingFlag !== value) this.endOfProcessingFlag = value;
    },

    // home画面へ遷移する
    onReturnToHomeOkButtonClick: async function () {
      this.modal_return_to_home_screen = false;
      this.$router.push({ name: 'home', params: { isAuto: false, isConfirmSkip: true } });
    },

    // IG-ON失敗画面表示時にイベントログを更新する
    updateImbEventLogIgOnFailed: async function () {
      await api.postCall(
        config.IMB,
        '/updateEventLogRecord/' + this.netAppId,
        { err_code: error.IMB_CANNOT_CONFIRM_IGON_ERROR }
      );
    },

    // Calling startRegistration api と Create Event Log Record を共通関数化
    startRegistrationAndCreateLogRecord: async function (functionName, startFunction) {
      // createEventLogRecord 処理を実施する間に他の操作をさせないためにスピナーを表示
      // ※startRegistration 内で processing を true にしているが、createEventLogRecord での対応が抜けていたため本処理を追記
      this.processing = true;
      await this.createEventLogRecord(functionName);
      await this.startRegistration(startFunction);
    },

    // Calling startRegistration api for regECU type1&2&3
    startRegistration: async function (endpoint) {
      this.igOn = false;
      this.processing = true;
      ecuCounter = 1;
      const token = session.getToken();
      try {
        const startImbResponse = await api.postCall(config.IMB, `${endpoint}` + this.netAppId, {
          id_token: token.id_token,
        });
        const isSuccess = handler.validate(handler.validateTypes.all, startImbResponse, this, null, () => { },
          (result) => { this.validation(result); }, null, false);
        if (!isSuccess) {
          this.processing = false;
          return;
        }
        // Start imb status monitoring
        await this.setupWatcher();

      } catch (error) {
        this.processing = false;
      }
    },

    // Create Event Log Record
    createEventLogRecord: async function (functionName) {
      await api.postCall(
        config.IMB,
        constants.IMB_CREATE_EVENT_LOG_RECORD + this.netAppId,
        { function_name: functionName }
      );
    },

  },

  created() {
    const pageObject = this.response ? JSON.parse(this.response) : null;
    if (pageObject !== null && pageObject !== undefined && immobilizer.isRunningImmobilizer(pageObject.imb_status)) {
      this.processing = true;
      this.isRequireGetProcessName = true;
      this.isReturnedFromDisconnection = true;
      this.setupWatcher();
    }
  },

  mounted() {
    this.$emit('setVehicleTabsAvailable', true);

    this.displayVehicleTypeWithFormatting();
  },

  beforeUpdate() {
    this.displayVehicleTypeWithFormatting();
  },

};